import {type FC, useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {Outlet} from 'react-router-dom';
import {GisContext, Login, type SupportedLanguage} from 'talptech-gis-components';
import 'talptech-gis-components/styles.css';

const LOGIN_URL = process.env.LOGIN_URL || '';
const GIS_API_BASE_URL = process.env.GIS_API_BASE_URL || '';
const CRM_API_BASE_URL = process.env.CRM_API_BASE_URL || '';

const AuthenticatedLayout: FC = () => {
  const {i18n} = useTranslation();

  const [accessToken, setAccessToken] = useState<string | undefined>(
    sessionStorage.getItem('accessToken') ?? undefined,
  );

  useEffect(() => {
    sessionStorage.setItem('accessToken', accessToken ?? '');
  }, [accessToken]);

  if (!accessToken) {
    return <Login url={LOGIN_URL} onTokenSet={setAccessToken} />;
  }

  return (
    <GisContext
      gisApiBaseUrl={GIS_API_BASE_URL}
      crmApiBaseUrl={CRM_API_BASE_URL}
      accessToken={accessToken}
      language={i18n.language as SupportedLanguage}
    >
      <Outlet />
    </GisContext>
  );
};

export default AuthenticatedLayout;
